function Loading() {
  return (
    <section className="box">
      <div className="shadow"></div>
      <div className="gravity">
        <div className="ball"></div>
      </div>
    </section>
  )
}

export default Loading